import { Button, Grid, TextField, Typography } from '@mui/material';
import React from 'react';

const UpdateForm = ({ data, setData, onUpdate }) => {
  return (
    <Grid container sx={{ p: 2 }} display="flex" justifyContent={`center`}>
      <Grid display="flex" flexDirection="column">
        <Typography
          style={{
            fontSize: '14px',
            marginBottom: '0.5rem',
            textAlign: 'center'
          }}
          variant="h4"
          component="h4"
        >
          Update
        </Typography>
        <TextField
          size="small"
          variant="outlined"
          inputProps={{
            max: 100,
            min: 0,
            style: {
              fontSize: '11px'
            }
          }}
          placeholder="Enter Value"
          value={data.title}
          onChange={(e) => {
            setData((prev) => ({
              ...prev,
              title: e.target.value
            }));
          }}
        />
        <Button
          sx={{
            mt: 2,
            width: '10%',
            fontSize: '13px',
            fontWeight: 'normal',
            background: '#0069E4',
            ml: 'auto',
            mr: 'auto'
          }}
          variant="contained"
          type="button"
          onClick={() => onUpdate()}
        >
          Update
        </Button>
      </Grid>
    </Grid>
  );
};

export default UpdateForm;
